module.exports = __webpack_public_path__ + "static/logo-68e2d730c93cd23b269ebd9c3faf8eb8.png";